module.exports = __webpack_public_path__ + "img/next.97e53920.svg";